// `lockedValues` renders a chip without its remove button - used for a value the user is
// shown but cannot take away, such as the report plan's own client on a metric.
export function ChipList({ values, onRemove, emptyText, getLabel, lockedValues, lockedTitle }: { values: string[]; onRemove?: (value: string) => void; emptyText?: string; getLabel?: (value: string) => string; lockedValues?: string[]; lockedTitle?: string }) {
    if (!values.length) return <span className="rc-hint">{emptyText || "None"}</span>;
    const locked = new Set(lockedValues || []);
    return <div className="rc-chip-row">{values.map((value) => {
        const isLocked = locked.has(value);
        const label = getLabel ? getLabel(value) : value;
        return <span className={isLocked ? "rc-chip locked" : "rc-chip"} key={value} title={isLocked ? lockedTitle || label : label}>{label}{onRemove && !isLocked && <button className="rc-x" onClick={() => onRemove(value)}>x</button>}</span>;
    })}</div>;
}
